import { styled } from '@mui/material/styles'
import { TextField, Button } from '@mui/material'
import { colors, fontFamily } from 'theme'

export const SearchContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
})

export const StyledTextField = styled(TextField)({
  width: '100%',
  backgroundColor: 'transparent',
  borderRadius: '8px',
  '& .MuiInputBase-inputAdornedStart': {
    boxShadow: 'none',
  },
  '& .MuiInputBase-input': {
    boxShadow: 'none',
  },
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    backgroundColor: 'transparent',
    paddingRight: '4px',
    '& fieldset': {
      borderColor: '#d7d7d7',
      borderWidth: '1px',
    },
    '&:hover fieldset': {
      borderColor: '#d7d7d7',
    },
    '&.Mui-focused fieldset': {
      borderColor: colors.primary.DEFAULT,
    },
    '& input': {
      padding: '10px 0',
      fontSize: '16px',
      fontFamily: fontFamily.inter,
    },
  },
})

export const SearchButton = styled(Button)({
  backgroundColor: colors.primary.DEFAULT,
  '&:hover': {
    backgroundColor: colors.primary.dark,
  },
  textTransform: 'none',
  fontFamily: fontFamily.inter,
  fontSize: '14px',
  height: '40px',
  width: '170px',
  lineHeight: '16px',
}) 